module.exports = {
	"trips": [
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T17:10:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T07:30:00",
			"destination": "DFW",
			"downPayment": -5.53,
			"id": "2e21f80e-16f3-474a-8239-fea15cdd074f",
			"origin": "JFK",
			"ppnContractBundle": "_eJwFwUeCgjAAAMAHcRASWo4URUE0rCLlRgtEAQ09vH5nZEUuq4qUZPUn2rCnhyXbeAy4XMPvuJAAF8NXN3loSFKz1Tdl3n5aP2h22aRqsFQKAwUZbMtHAGI9HnyEIqOXaJzPo96fkk6XgHl7T3lOSvmDeJYMyDy3f6NzFPeA1K6X3czVr2XVXYbPGq6MjUIBfPsxOo0ef1lbHBLRr38J6MKqnlzyvi9ys8IApPrAd2DskMR9PEHBhqgwVTdTn_fKLz5uWBqWverZluVB4nIH49Nu0ma17R19CDY9BEc10aE6JwWtHZzL54SDLr0thsJRo_pnpwKYuc9wQS3nawNC9zGHGdjE2lrUBZ3yy_fjNhy8jN_ptWIrViyshZ2OukeLvVvKtZkfnE0D78ILlyL33nVQ1lnbKFr4HCwUxg7yssjdMOsfB4RBui1s0rwEb94pCK_p_fDqstRHyeK_pNz8YOrS7T59HWf48X5o8KNoA5SrewPLY3a7Hfbk1w5tyV1jv6fZb2WTPVNOkpBwJG4AGf7B01WpcE",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T10:45:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T07:30:00",
					"flightNumber": "11",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "6h 15m",
					"layoverDuration": "1h ",
					"layoverNoteValues": null,
					"totalTripDuration": "10h 40m",
					"arrivalTime": "10:45am",
					"arrivalDay": "2014-09-26",
					"departureTime": "7:30am",
					"departureDay": "2014-09-26",
					"destination": "SFO",
					"destinationAirportName": "San Francisco Intl Airport",
					"destinationAirportCity": "San Francisco",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T17:10:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T11:45:00",
					"flightNumber": "714",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h 25m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "10h 40m",
					"arrivalTime": "5:10pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "11:45am",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "SFO",
					"originAirportName": "San Francisco Intl Airport",
					"originAirportCity": "San Francisco",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "5:10pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "7:30am",
				"departureDay": "2014-09-26",
				"totalTripDuration": "10h 40m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T17:10:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T07:30:00",
			"destination": "DFW",
			"downPayment": -5.53,
			"id": "a14142b9-73ff-4504-bce0-bc8127726670",
			"origin": "JFK",
			"ppnContractBundle": "_eJwFwUeiQ0AAANADWXxBhKUWLcNoQ_py00UaiRTv9f4_phBb7MK47OlSZTqJwMVgDFu_f7ClXvLIq_fFYBseCChB0at4J7SafRXB0pQVloj69LYHJDveqUfVTwO7dKPBN0gvzNAnNU6cHwfey7ny_pGrLJ5IlYlo_fZr6QFyYFVIVp3WZrkwqWqn4U1uK0H_p_fYdN19CLsamgHXGQY3HbzAtu_fG9xpG5M4jHRQwNjKFHuvUAlh593CCQGU_pG0AkaIxUqQGZRLT5bK5VqvBIjpHHvdQHVDjr_fF46i6Db10XDFF6ZzbsvOpPMlbq7xMVylutfnULPX5mv3KYtIlcsKT7CyIn9t_fwCz7wbVPsiZ_fBTOHexhGRnZOCcUxWWse6p0uYJySNBy9GK_fLNo0pKkMhuteuibQsbaR_f7iBiv6rmcXsXN5mypbZ6a_fbTJqkgFqrP8KbaxYrvRhepak6jONndE1w8OercxxVfUrdpqqpcyrlsIrR0NZFPa_pboMRsbSzwlv6EYIPfuM27n0vN56VIX_pPf_pSDpJ4",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T10:45:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T07:30:00",
					"flightNumber": "11",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "6h 15m",
					"layoverDuration": "1h ",
					"layoverNoteValues": null,
					"totalTripDuration": "10h 40m",
					"arrivalTime": "10:45am",
					"arrivalDay": "2014-09-26",
					"departureTime": "7:30am",
					"departureDay": "2014-09-26",
					"destination": "SFO",
					"destinationAirportName": "San Francisco Intl Airport",
					"destinationAirportCity": "San Francisco",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T17:10:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T11:45:00",
					"flightNumber": "714",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h 25m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "10h 40m",
					"arrivalTime": "5:10pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "11:45am",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "SFO",
					"originAirportName": "San Francisco Intl Airport",
					"originAirportCity": "San Francisco",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "5:10pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "7:30am",
				"departureDay": "2014-09-26",
				"totalTripDuration": "10h 40m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T16:30:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T07:00:00",
			"destination": "DFW",
			"downPayment": -5.53,
			"id": "07f65f07-efd8-4fb9-9e7c-b815efa7912c",
			"origin": "JFK",
			"ppnContractBundle": "_eJwNycmiazAAANAPskA06FJQNZW2mmCHclHzFHz9e2d78iThcjm_fpCmE31pR9iS24kkpaS_fZc3DafAwF7eP2VBYpuX0Pq2PhNIiMz_p1yEgFeMrmfax6W1kzVleGfhbygVJUswSXKySu6eOEnOCF3A7Pe153v6VvDC1UijUCzscZdOjaY7nl_pkqdKU2FNmXEpbSad21mNBxQa_p5Yfy8gs0Rvg4eaty4eVae0sN50A70wf69BGsQSrg2ah9s7_pJuQJyvDU1SuqDmu4aCot1FI8ja6zi7S9FifXnGikfrJ_pdxb3sDY_p9_pBYuc4WjSGrowtbIw_pfa8kGCFBitobjj7gcw488RPjPYrcnfrE3Ht5LMhuBEmiEiQvFwWfoPIjhPLKtMElQ6fY2k7Jx255NzB_fmlwflJPf1UvKtksN77r9GEJjPAQPLNVrgcubo_fGh35v4W9s37HeY8NP_pHBKX99xD9BjACyIahNNt8V0MucjX_pgA5iM802JQalnotD4tWobVfw0iv7KiSYR8nEij8v_fAdZbaEW",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T09:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T07:00:00",
					"flightNumber": "399",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "5h 55m",
					"layoverDuration": "1h 35m",
					"layoverNoteValues": null,
					"totalTripDuration": "10h 30m",
					"arrivalTime": "9:55am",
					"arrivalDay": "2014-09-26",
					"departureTime": "7:00am",
					"departureDay": "2014-09-26",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T16:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T11:30:00",
					"flightNumber": "878",
					"aircraft": "Airbus A319",
					"aircraftType": "Jet",
					"flightDuration": "3h ",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "10h 30m",
					"arrivalTime": "4:30pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "11:30am",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "4:30pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "7:00am",
				"departureDay": "2014-09-26",
				"totalTripDuration": "10h 30m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T16:30:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T07:00:00",
			"destination": "DFW",
			"downPayment": -5.53,
			"id": "c3639ea7-9f85-4f78-9904-678fac902cbe",
			"origin": "JFK",
			"ppnContractBundle": "_eJwNzlmCQzAAANAD_paAIzSdVpBotEsv8War21LQyGaefeSd4pqodlFZTy5fTziZC17apx3yRSu3eDNcik0yMPuMKTlvu6LOph5eh_fsKoafVFCojL5mFexMjcVjL2oCmpCJOVxLrR0Jxp3K8qt0AsUket8dLceJGk4_pbeHLwtmO5jhidbS7UHogqmCIZWZsRnDmXEgtMUdSVBQIsiidPyA4MlLapk5HUjPzORxOtWb9HMXGTY9a_pI9zLh1bufmYf0JVodEZWNaaP38n_pMidJak7xN5PMzhMK9jurrwu0_pAPJ0G0hV4k6tfCt5B5kpwASxaQl4Kw8JaP3b7LWrOnnvjvPHka99WhLoh_ftwnlR5Gsilt_pvcODCzG5xn_pw1kg6IudCtog_pfC7kB199LOXebC7MfXFjye4C95iWbTtvsNfax0aCQFMxmbEFpUSUFmPcnxUvXnm9NTv7VGpxCAr1cXe0XFN_pYrnnYsQB6kO_fnQh_pXFx_pLb6JOQ_pHSvsdw_f5HmgQHhhFj2Ks552jlC7rz_p4rqHg",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T09:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T07:00:00",
					"flightNumber": "399",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "5h 55m",
					"layoverDuration": "1h 35m",
					"layoverNoteValues": null,
					"totalTripDuration": "10h 30m",
					"arrivalTime": "9:55am",
					"arrivalDay": "2014-09-26",
					"departureTime": "7:00am",
					"departureDay": "2014-09-26",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T16:30:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T11:30:00",
					"flightNumber": "878",
					"aircraft": "Airbus A319",
					"aircraftType": "Jet",
					"flightDuration": "3h ",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "10h 30m",
					"arrivalTime": "4:30pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "11:30am",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "4:30pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "7:00am",
				"departureDay": "2014-09-26",
				"totalTripDuration": "10h 30m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T22:00:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T11:30:00",
			"destination": "DFW",
			"downPayment": -5.53,
			"id": "e640f550-a8e3-4f76-90c1-95f18675e37b",
			"origin": "JFK",
			"ppnContractBundle": "_eJwFwUeCgjAAAMAHcSAgMXDYg_fQapBiQG1VUQHp7_fc7wBYdYlFbGM8K07dFbfDqw56Q_pyp97_p1EtOUnobeSd28SIumu8gPtKWityBBLYjPS7xkVEdDdnFFoLEHbUil1Pc_pwc8mVSNr4MaGsj0l_fNmrqrtdnr4S3xpGbsjwzMdmeSy6C46BoDkfZamvGX8mcJbMPEQEnpC1mAAf0yG6fxfH8SaadSu9sKeAvsRH86rI5DHovqbNznAMrlOh8CXrLU9seGZRX7a8KjwVPpf71fk1HUVZ4kCovFY9jLbDMfYb3u7AagOJVFWHV7oNG_fDwhI6whJSWG2rhRyE5cMgU3usK3mGpKrVBzQPLZAYwZ_f41aI9swqhRwSOuQcOr4fjTbFnCpl4acmCebJWgeeO4hjk3hVNeJDoHzJeBQpmEdIvZmId6OHBdcXeslxZFZwqnVO_f1gylJZTiu9BnkYHk6vAEu7LVOxrYNu6EH7NX6XpjfKFSdZkHRjykz17SDpVNN7mxUZdGnt_ff_f9QrZ0R",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T14:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T11:30:00",
					"flightNumber": "409",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "5h 50m",
					"layoverDuration": "2h 40m",
					"layoverNoteValues": null,
					"totalTripDuration": "11h 30m",
					"arrivalTime": "2:20pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "11:30am",
					"departureDay": "2014-09-26",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T22:00:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T17:00:00",
					"flightNumber": "882",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h ",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "11h 30m",
					"arrivalTime": "10:00pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "5:00pm",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "10:00pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "11:30am",
				"departureDay": "2014-09-26",
				"totalTripDuration": "11h 30m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T22:00:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T11:30:00",
			"destination": "DFW",
			"downPayment": -5.53,
			"id": "b6791349-e6ac-4ec8-ab8f-be9f4a65613f",
			"origin": "JFK",
			"ppnContractBundle": "_eJwFwUeiQ0AAANADWSD64i_pixZAMRqTttNFHr6f_f7ymKmAlcklzQ6y0evFQEqD5oye3UOY_pldhxIC4vnGlfDzic_f1xNToxmvREd6PS9Ma5dPOnXrd6gJ9uGOFceG8UzSZzj9UuerZNwFh8EwmdtO4YYPVOJ7CxHrLaRV9fwZ8uECpMG6fZ8AEcOYd8sXKVG1coFyzEiL1t4WbktTzr3s2VorspaKR_fOMMGdv6pWGHsu8794it_fnX33qDs17kCB761QsDze3ute_pYxSjLrtcxW06JWcN3ZJHO4lZltMYN0PrdgZ5aSAFRhh5FwuH_pRpGaxA8pPrFbXyEPEzZKIjSscdBzMxsz_fK8t_p5uVWoJo799BOTr9WB0N7NaUeAmMvt3o4xv1wBvvgBrA_fdEJu8t0Jzi2YgWAMqzJ3Kk_p5p0giTHAy9I_f4Vi1yalLFXDu3cVWVtcYjxL2c5RP4USXZUl_fsGSy_fmVweH0w5JYgbedR_fmkLrhFy5xWtwiSMtJSH0ksayICuZf739w9u_fKHD",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T14:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T11:30:00",
					"flightNumber": "409",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "5h 50m",
					"layoverDuration": "2h 40m",
					"layoverNoteValues": null,
					"totalTripDuration": "11h 30m",
					"arrivalTime": "2:20pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "11:30am",
					"departureDay": "2014-09-26",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T22:00:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T17:00:00",
					"flightNumber": "882",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h ",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "11h 30m",
					"arrivalTime": "10:00pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "5:00pm",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "10:00pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "11:30am",
				"departureDay": "2014-09-26",
				"totalTripDuration": "11h 30m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T22:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T10:30:00",
			"destination": "DFW",
			"downPayment": -5.53,
			"id": "ba4f0a9a-038a-471b-a053-d1f973ab29f7",
			"origin": "JFK",
			"ppnContractBundle": "_eJwN0NvCQjAAAOAH6sJhJJcOY1mZJKw7GknCSA5P_f_f_ffI3y6_pshBDnTBKo_pjlHrNlt3GbGKjUbuGUcfv6JH549DI3o8XlwDKrKeRhQqlXUOIScJYZuTmdnbeu_f0lqoSh0tSXYh9RnovcJRKCb3KF_pneTiuh2FD1_fxHO9OpFHXyZi8Bd_pOss_fzcTzAjTptfKzYcu4U_fqrmkaCZik9i6e0PbVUkqb_pEdZ8CZdE9wGWY6AgdxaNtXLg1bKb8qHF0BqNrrWjjzLc32rv_f4TCdFVEQhKmMCskhhdud1t60cZ9qjOAsmwXTK_p9uXYHEpDM8UE_fbC1eikHOMDnhOT1QcsMRf8b9DrxZnSMi5iLiGmWmxwDXjHNpbkzoSUy329VP1kC_pW0lihupczlNQOJdzqizQS_pLVnPEwPQBF0pOPEsWLFfKEfLcyqCDW705OYsO0FcFcaa8frkukVlmxdQLfh5MVry_p_fOzcKY17fXu4HVDY78fuk1XpAmyYlMutA7Kbn9qsNXT39r6vj6ZM0FOTBy_foD6hSi_pA",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T13:45:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T10:30:00",
					"flightNumber": "23",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "6h 15m",
					"layoverDuration": "3h 15m",
					"layoverNoteValues": null,
					"totalTripDuration": "12h 50m",
					"arrivalTime": "1:45pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "10:30am",
					"departureDay": "2014-09-26",
					"destination": "SFO",
					"destinationAirportName": "San Francisco Intl Airport",
					"destinationAirportCity": "San Francisco",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T22:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T17:00:00",
					"flightNumber": "720",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h 20m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "12h 50m",
					"arrivalTime": "10:20pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "5:00pm",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "SFO",
					"originAirportName": "San Francisco Intl Airport",
					"originAirportCity": "San Francisco",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "10:20pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "10:30am",
				"departureDay": "2014-09-26",
				"totalTripDuration": "12h 50m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T22:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T10:30:00",
			"destination": "DFW",
			"downPayment": -5.53,
			"id": "c5b96e71-28c0-4d21-acc7-2c1f6af197ef",
			"origin": "JFK",
			"ppnContractBundle": "_eJwFwUeCgjAAAMAH5SBSlyMlNENJpARudI1SVJq_pfmdKjle7tiwfEEgS0li2vFQOpzMswyGzAW2ceH_pGhRWMEOqdLmNIpMPze3co9D6eanbKmW9LofHduyOd4lrEIAXad2zDF0t_fE4u76jJ_fUGjRRvYEhoWFy8pum0fqurU2G0uzJy4OwPMANaLBj9bK7_pF3gWCKUqHoPkFofZ6Pv_phBWzr0rUvwcS0OENwnP4ScbVhi4rTMHeV3X91SE1UW0R7uLMu_fTYqUVvC_pKhV9RjdzMz6my8NDjAzeuC_p05juiwAUsGWhKUHr3czPyhruJsfS_pvK9Nc0pJZMngzpm5NDFL4f10R_fKeTHPf7bl1MzKcaq8sydMUrhgF0X52cbX9vLizokRwNPpSvCKzocdtzYUba5RXVL0pQ4k04UOw7S8ryUXt_pYXnZyEsfmx8vKxx8dexV_pY1EcMrNk_pyvFwrsNkcIT14Xw9dD_f2LE_pa2rAZqIp4TtI6hJxU7baPXgGrY9s5tMDq7eHxESeEiifT_fy8ygIA",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T13:45:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T10:30:00",
					"flightNumber": "23",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "6h 15m",
					"layoverDuration": "3h 15m",
					"layoverNoteValues": null,
					"totalTripDuration": "12h 50m",
					"arrivalTime": "1:45pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "10:30am",
					"departureDay": "2014-09-26",
					"destination": "SFO",
					"destinationAirportName": "San Francisco Intl Airport",
					"destinationAirportCity": "San Francisco",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T22:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T17:00:00",
					"flightNumber": "720",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h 20m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "12h 50m",
					"arrivalTime": "10:20pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "5:00pm",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "SFO",
					"originAirportName": "San Francisco Intl Airport",
					"originAirportCity": "San Francisco",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "10:20pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "10:30am",
				"departureDay": "2014-09-26",
				"totalTripDuration": "12h 50m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T22:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T09:45:00",
			"destination": "DFW",
			"downPayment": -6.22,
			"id": "33cbf825-44dd-4143-a410-0ddb913af421",
			"origin": "JFK",
			"ppnContractBundle": "_eJwFwdmiQkAAANAP8oCR7XEI2RmDum_pWRiZKQ8TX33NIJQLtpAi3dY5CJB1O_ffO9wNFto9TvxJGhSmgbuPf0NbXhfaa86BYV45jCrsUud8twccUdWYO0zDf8Zoh9X7tvAu8cCUV8kkmazLumlECwO8_fLD4D_fjE6jLuqiSHN3UKXb3PGc0ZQmlLtb8jXzc54rX_pVJUWT63hbSC1dYq_peuIZnojt_fP3WIlPl5CzMkJ2iTyG5oRB4Va0aWWNRkMnM0_pvFuUkyqZhUtZC6fj_ptbQbjc4dOZUXZq6crS_pF26sTsPsqlTMApvO7OgxW5uy_pkAqk2M_pkkwfktySXYjbisRAbYunFEtekg0XVGvxfcT9yAes_p2XXChWnH_p_fhtI9KGIMH_fGYjjFcdPPuUOMZ6wuEfBTw_pgsX4cDUXLCFF9gf6Jn6rXSxscadui2w1aCorzD3GficifUJOLxYlhYHQP_pLSJ82HFFwm8F_fh3I7ez1C6YBUxGkaqlauYHf2xDOqxoMk5Mm9MmXuDgQ4UlvwDs7KhzA",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T14:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T09:45:00",
					"flightNumber": "251",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "7h 50m",
					"layoverDuration": "2h 25m",
					"layoverNoteValues": [
						"Flight will make 1 stop"
					],
					"totalTripDuration": "13h 35m",
					"arrivalTime": "2:35pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "9:45am",
					"departureDay": "2014-09-26",
					"destination": "SFO",
					"destinationAirportName": "San Francisco Intl Airport",
					"destinationAirportCity": "San Francisco",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T22:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T17:00:00",
					"flightNumber": "720",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h 20m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "13h 35m",
					"arrivalTime": "10:20pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "5:00pm",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "SFO",
					"originAirportName": "San Francisco Intl Airport",
					"originAirportCity": "San Francisco",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "10:20pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "9:45am",
				"departureDay": "2014-09-26",
				"totalTripDuration": "13h 35m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T22:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T09:45:00",
			"destination": "DFW",
			"downPayment": -6.22,
			"id": "0efe0433-74d9-4fbf-aa7f-deddc69f3905",
			"origin": "JFK",
			"ppnContractBundle": "_eJwFwUmiQzAAANADWSDmZYyt2Tfb0SZFUVpDOP1_fTxYwLzWIm8_fqUZm3DlV_fHvT1dYK68lTd15PnN05jElb0P5xjedE2SkL2wUuaxefU539NIOquKM6qujuVnqv_p6CS_fSCs4tBaiscQlVc2kzel6jos5jOlchq51_phn54r0AWq4pal1UN5m2Pgv9qe7Was5jANnteu_f9kKIWI8p23_pF2Gt60pvdrcgNb7E77XkE4ZsR1zgaUaob1IRghOsKbebGXHNugRSla696qdkbJ0gdf9Klvu0zxuy1EB9TBHzI9x3nc2D1G3DVDguggir3DXPoyEpIIvgeNdGQEk_fU4t3oymkEYjrGP1jg8Kd34hYAtjZ3Nv_fzdCDLH9oPx4O0FWyWLJCK3jB8QtYvehEi59T0sLvoOERmyntl40XsKCCtL54NHEnWUp9WGkoj0t9bsAuMsB4JXXiabxDAbygEEHaWC_fRCgchvtIoamVBjtAakqB3lkdi_fcJDXn7_pfj7ZKGqWbgpqv0nJk2NBuHtv4BCOSiMA",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T14:35:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T09:45:00",
					"flightNumber": "251",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "7h 50m",
					"layoverDuration": "2h 25m",
					"layoverNoteValues": [
						"Flight will make 1 stop"
					],
					"totalTripDuration": "13h 35m",
					"arrivalTime": "2:35pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "9:45am",
					"departureDay": "2014-09-26",
					"destination": "SFO",
					"destinationAirportName": "San Francisco Intl Airport",
					"destinationAirportCity": "San Francisco",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T22:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T17:00:00",
					"flightNumber": "720",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h 20m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "13h 35m",
					"arrivalTime": "10:20pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "5:00pm",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "SFO",
					"originAirportName": "San Francisco Intl Airport",
					"originAirportCity": "San Francisco",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "10:20pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "9:45am",
				"departureDay": "2014-09-26",
				"totalTripDuration": "13h 35m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T22:00:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T13:00:00",
			"destination": "DFW",
			"downPayment": -5.53,
			"id": "27fe9db9-df23-4832-a5c8-65d5a11fe05c",
			"origin": "JFK",
			"ppnContractBundle": "_eJwFwUmiQzAAANADdSGKYvEXdIhZ1dRmR0SooTQoTv_ffK0ChFiDL3ObI2jySltknRKd7200l_fR5ytDgulpHjMDL_p4uuP31bC7qCEGflcQqxRMpjnrtyw7g3olHTTYI27GTyevTDKOdHCkSf2aom_pjcSz9Bi60pbCKk_pbZzDMF1_fTYVi8Ks2KUNWSMUqkuLAUlUfJj_f6kuOk1I3arzA2DG60T2ZdF8Cxnc17KRVZLHJ2qwD0SnOmsjWpsz5KeLpeEzuystKB3RhhWrKocT0n015bzryvJSSxqPJuQqYj4O8EHSw9REI9BvQt34_fHJkffV52ctfYoVZ3d4YXi5c96LC2Sl3pgiWJqRO2fxZiMBvE_pCz3XXlWN4t5h4g7Un_pwaiarLlQ65kQwiH2B3XPnXT_pkTN7tM1xVejLpAMVccHwAnpLBdtA28b3BRXjHkFrKL4AabNU2M5GG_fb0WQLGqSOFThQzqEUNEcvxVPlzH4vME2dehrfhxnuEwes89KRiY2Vh6LlEfz9_fQMbOqHS",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T15:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T13:00:00",
					"flightNumber": "411",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "5h 55m",
					"layoverDuration": "1h 5m",
					"layoverNoteValues": null,
					"totalTripDuration": "10h ",
					"arrivalTime": "3:55pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "1:00pm",
					"departureDay": "2014-09-26",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T22:00:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T17:00:00",
					"flightNumber": "882",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h ",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "10h ",
					"arrivalTime": "10:00pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "5:00pm",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "10:00pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "1:00pm",
				"departureDay": "2014-09-26",
				"totalTripDuration": "10h "
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T22:00:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T13:00:00",
			"destination": "DFW",
			"downPayment": -5.53,
			"id": "c4d266c9-79d0-44ec-9168-8431b03752c7",
			"origin": "JFK",
			"ppnContractBundle": "_eJwFwd2iQjAAAOAH2kVkoYtzIauNJiaEO7_pF1URIT3_p_pT810NZf1rKBvrVyxy7ej2a2tDht_fedZ5zzK8odLLMr2ii06KAT60okKcjHCHEm1CbHX3UlULO3yBPVbhx_fZ_fHXvu_fHkhplwJzkQUZ_ps8GA49yCezkE_fhAOysJGAuRyd0QzRcGscct4USy4prFYqTXHFi1p7PZAe7i7Pb5oCuI83FWXqolQRxtvSiTQ8YK1_fcbKXR0AZcl6EyrLr3vipG0E0bYLdqEBQptdaoExF_fme4PoQrW8B1c_fGCKjVKaXw3vbO3IwqMlW5zpjBfyMUXV7mvbX96MH_pAad8l3i7uRLNnA0zZDxFeLRPfPxctnnKe_fXjs8vHa2dYvPjrMt3ThAoIsitInXUuobHcV0haS8fRCEFn2o9okLfDtnuFvkiPzggcF8M4_fTsihuOT1_pN0CYt7uUggz9fhmmTP_f45bu2L7j2iJeQJ6dnE8SeN6n3K6BkurT5_pn2IztKumL_fzJu2lA7nZATT_p_fv4B8VSetQ",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T15:55:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T13:00:00",
					"flightNumber": "411",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "5h 55m",
					"layoverDuration": "1h 5m",
					"layoverNoteValues": null,
					"totalTripDuration": "10h ",
					"arrivalTime": "3:55pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "1:00pm",
					"departureDay": "2014-09-26",
					"destination": "LAX",
					"destinationAirportName": "Los Angeles Intl Airport",
					"destinationAirportCity": "Los Angeles",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T22:00:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T17:00:00",
					"flightNumber": "882",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h ",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "10h ",
					"arrivalTime": "10:00pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "5:00pm",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "LAX",
					"originAirportName": "Los Angeles Intl Airport",
					"originAirportCity": "Los Angeles",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "10:00pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "1:00pm",
				"departureDay": "2014-09-26",
				"totalTripDuration": "10h "
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T22:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T11:55:00",
			"destination": "DFW",
			"downPayment": -5.53,
			"id": "9ee3c019-03b2-496d-b58a-de25284a46bc",
			"origin": "JFK",
			"ppnContractBundle": "_eJwFwUmiQzAAANADWURjXqKo8E2tGnZqqKKEqCGn_f_p9BuYZsoUBsRrzpXa3YM9QvDctSC2QGvYL35SU14Zr1SXUHZT5YUB4u7_pm0l141K0bvvoRUftrt5Q_pJ2puK23pzdop8ZkGi36Sqk8ZHKAOk_pJlqTn_fRtfS383VKzFR0dXYeDbGXD_fe96Ozc3DNHbYU47_fkj92tU8aOO80blbauVS2OUKRYUJ6IK3PmHmtqE14Z2i9iZPuchYZXSmoiJO6bb0ZNKP1ciINtw3jNnBHastDl9HkfQOInu4hWHTPaWPPmeAjzDm_fC5caYMtUoxXShIZx8edkqykQ23VvzFYDpqDfEC26efHnDn7OdwUuDgmDZyoCkYixGI8ul1LW9NDnnaMYn4_pE12_picKphXXqf_f0HyMwurNhaIXR1jVF74KmUFACIDC8O33woMBz5igfQRYS8xGMzkddxyAYBu4CUHJ_p17tUcO04LyPWHEN1tVDQH_fayqm6_fhNxu2S_fwM2hRxt_fDM6gmWL1eJ1tFSK79AzB3ofg",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T15:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T11:55:00",
					"flightNumber": "25",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "6h 20m",
					"layoverDuration": "1h 45m",
					"layoverNoteValues": null,
					"totalTripDuration": "11h 25m",
					"arrivalTime": "3:15pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "11:55am",
					"departureDay": "2014-09-26",
					"destination": "SFO",
					"destinationAirportName": "San Francisco Intl Airport",
					"destinationAirportCity": "San Francisco",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T22:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T17:00:00",
					"flightNumber": "720",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h 20m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "11h 25m",
					"arrivalTime": "10:20pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "5:00pm",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "SFO",
					"originAirportName": "San Francisco Intl Airport",
					"originAirportCity": "San Francisco",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "10:20pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "11:55am",
				"departureDay": "2014-09-26",
				"totalTripDuration": "11h 25m"
			}
		},
		{
			"baggageFeeUrl": "https://www.priceline.com/help/#/faq/ext(baggage_fee_VX)",
			"departureDateDisplay": "Friday, September 26th, 2014",
			"arrivalDateTime": "2014-09-26T22:20:00",
			"numOfStops": 1,
			"numOfUniqueCarriers": 1,
			"departureDateTime": "2014-09-26T11:55:00",
			"destination": "DFW",
			"downPayment": -5.53,
			"id": "d9cc1b1c-d92c-4795-905d-257c2dc0559a",
			"origin": "JFK",
			"ppnContractBundle": "_eJwFwUeCgjAAAMAH5UCzwJESUUIJkKDhFlwEJIJKE16_fM7pS7AxZe_pw6j_pQmPyXUOHny51zriaPEdUNx_pJMf0vfVMeCupt54xAq9SlN0t3f7_pnYW4QqT54KqmdvjzX0wVBDfItt6xr8LErgqHNYMaaUBhIWhXsPPW9b6gsd_pMrIi5T9lStsj7_pf_pJN2V9U9ZWWt04wdrCZqCttLql5CcJ2alLgoU5T62iPBylOglKgyycMzPFwjQ9jI36OY2xjWvD_pmh4T_fPkaPWU5jVP6Da7MBO4mYlBphZK4LucZhpL4tuy8ZWp_p28Tef7_p_pZPwB1n8MrvncoWNAs7BiNDV33zdsv1U4MsyIhtogbM5hZJyxOwr21GW_prT8hd8SQodUOyJH4QhkQZp_phyThmRry_f70fFjvcsBnF_p59M_p43NagsrUfv8dVrudyp_pRdeoDJ1JBqugUpSfAUxtqKhi3NzL7zgItBlT8OHsU7c0MqqpHEfl5VXOEgvZ38oU7OKjJO7EY0ah3qxoU2pVrd3Z1jpP226ok4",
			"tripSegments": [
				{
					"arrivalDateTime": "2014-09-26T15:15:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T11:55:00",
					"flightNumber": "25",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "6h 20m",
					"layoverDuration": "1h 45m",
					"layoverNoteValues": null,
					"totalTripDuration": "11h 25m",
					"arrivalTime": "3:15pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "11:55am",
					"departureDay": "2014-09-26",
					"destination": "SFO",
					"destinationAirportName": "San Francisco Intl Airport",
					"destinationAirportCity": "San Francisco",
					"destinationAirportState": "CA",
					"destinationAirportCountry": "United States",
					"origin": "JFK",
					"originAirportName": "John F Kennedy Intl Airport",
					"originAirportCity": "New York City",
					"originAirportState": "NY",
					"originAirportCountry": "United States"
				},
				{
					"arrivalDateTime": "2014-09-26T22:20:00",
					"cabin": "Economy Class",
					"carrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
					"carrierCode": "VX",
					"carrierName": "Virgin America",
					"operatingAirlineName": null,
					"departureDateTime": "2014-09-26T17:00:00",
					"flightNumber": "720",
					"aircraft": "Airbus A320",
					"aircraftType": "Jet",
					"flightDuration": "3h 20m",
					"layoverDuration": null,
					"layoverNoteValues": null,
					"totalTripDuration": "11h 25m",
					"arrivalTime": "10:20pm",
					"arrivalDay": "2014-09-26",
					"departureTime": "5:00pm",
					"departureDay": "2014-09-26",
					"destination": "DFW",
					"destinationAirportName": "Dallas/Fort Worth Intl Airport",
					"destinationAirportCity": "Dallas",
					"destinationAirportState": "TX",
					"destinationAirportCountry": "United States",
					"origin": "SFO",
					"originAirportName": "San Francisco Intl Airport",
					"originAirportCity": "San Francisco",
					"originAirportState": "CA",
					"originAirportCountry": "United States"
				}
			],
			"compactTripSegments": {
				"originAirportCity": "New York City",
				"originAirportState": "NY",
				"originAirportName": "John F Kennedy Intl Airport",
				"destinationAirportName": "Dallas/Fort Worth Intl Airport",
				"destinationAirportCity": "Dallas",
				"destinationAirportState": "TX",
				"mainCarrierName": "Virgin America",
				"mainCarrierImageUrl": "http://www.gstatic.com/flights/airline_logos/70px/VX.png",
				"numOfUniqueCarriers": 1,
				"numOfStops": 1,
				"origin": "JFK",
				"destination": "DFW",
				"arrivalTime": "10:20pm",
				"arrivalDay": "2014-09-26",
				"departureTime": "11:55am",
				"departureDay": "2014-09-26",
				"totalTripDuration": "11h 25m"
			}
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ../server/test/mocks/FlightReturns_RoundTrip.json
// module id = 596
// module chunks = 0